var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "custom-box",
    {
      attrs: {
        title: "比赛布阵",
        visible: _vm.dialogFormVisible,
        modal: false,
        "modal-append-to-body": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: function($event) {
          return _vm.rewriteClearData()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "popover", staticStyle: { "flex-direction": "column" } },
        [
          _c("div", { staticClass: "lineup-container" }, [
            _c("div", [
              _c("span", { staticClass: "team-name" }, [
                _vm._v(
                  _vm._s(_vm.matchInfo.home_team_name || "主队") +
                    " vs " +
                    _vm._s(_vm.matchInfo.away_team_name || "客队")
                )
              ]),
              _c("span", { staticClass: "match-time" }, [
                _vm._v(
                  _vm._s(
                    _vm.matchInfo.match_time +
                      "-" +
                      _vm.matchInfo.estimated_end_time
                  )
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "formation-tabs" },
              _vm._l(_vm.formations, function(formation) {
                return _c(
                  "div",
                  {
                    key: formation.key,
                    class: [
                      "formation-tab",
                      { active: _vm.activeFormation === formation.key }
                    ],
                    on: {
                      click: function($event) {
                        return _vm.switchFormation(formation.key)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(formation.key) + " ")]
                )
              }),
              0
            ),
            _c("div", { ref: "pitch", staticClass: "pitch" }, [
              _c(
                "div",
                {
                  staticClass: "position",
                  style: _vm.getPositionStyle("GK"),
                  attrs: { "data-pos-key": "GK" }
                },
                [
                  _vm.positionPlayers.GK
                    ? _c("div", { staticClass: "player draggable" }, [
                        _vm.positionPlayers.GK.player_status != "sent_off" &&
                        _vm.matchInfo.status != 2
                          ? _c(
                              "span",
                              {
                                staticClass: "remove-btn",
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.removePlayer("GK")
                                  }
                                }
                              },
                              [_vm._v("×")]
                            )
                          : _vm._e(),
                        _c("img", {
                          staticClass: "avatar",
                          class: {
                            "status-sent-off":
                              _vm.positionPlayers.GK.player_status ==
                                "sent_off" || _vm.matchInfo.status == 2
                          },
                          attrs: {
                            src:
                              _vm.positionPlayers.GK.avatar ||
                              require("@/assets/images/default_avatar.png")
                          }
                        }),
                        _c("div", { staticClass: "position-name" }, [
                          _vm._v(_vm._s(_vm.getPositionCN("GK")))
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "player-name",
                            class: {
                              "name-sent-off":
                                _vm.positionPlayers.GK.player_status ==
                                  "sent_off" || _vm.matchInfo.status == 2
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.positionPlayers.GK.name) +
                                "#" +
                                _vm._s(_vm.positionPlayers.GK.jersey_number)
                            )
                          ]
                        )
                      ])
                    : _c("div", { staticClass: "empty-position" }, [
                        _c("div", { staticClass: "dot" }),
                        _c("div", { staticClass: "position-name" }, [
                          _vm._v(_vm._s(_vm.getPositionCN("GK")))
                        ])
                      ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "position-group",
                  style: _vm.getGroupStyle("DEF")
                },
                _vm._l(_vm.currentFormation.DEF, function(pos, idx) {
                  return _c(
                    "div",
                    {
                      key: "DEF-" + idx,
                      staticClass: "position",
                      style: _vm.getPositionStyle("DEF-" + idx),
                      attrs: { "data-pos-key": "DEF-" + idx }
                    },
                    [
                      _vm.positionPlayers["DEF-" + idx]
                        ? _c("div", { staticClass: "player draggable" }, [
                            _vm.positionPlayers["DEF-" + idx].player_status !=
                              "sent_off" && _vm.matchInfo.status != 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "remove-btn",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.removePlayer("DEF-" + idx)
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                )
                              : _vm._e(),
                            _c("img", {
                              staticClass: "avatar",
                              class: {
                                "status-sent-off":
                                  _vm.positionPlayers["DEF-" + idx]
                                    .player_status == "sent_off" ||
                                  _vm.matchInfo.status == 2
                              },
                              attrs: {
                                src:
                                  _vm.positionPlayers["DEF-" + idx].avatar ||
                                  require("@/assets/images/default_avatar.png")
                              }
                            }),
                            _c("div", { staticClass: "position-name" }, [
                              _vm._v(_vm._s(_vm.getPositionCN(pos)))
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "player-name",
                                class: {
                                  "name-sent-off":
                                    _vm.positionPlayers["DEF-" + idx]
                                      .player_status == "sent_off" ||
                                    _vm.matchInfo.status == 2
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.positionPlayers["DEF-" + idx].name
                                    ) +
                                    "#" +
                                    _vm._s(
                                      _vm.positionPlayers["DEF-" + idx]
                                        .jersey_number
                                    )
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "empty-position" }, [
                            _c("div", { staticClass: "dot" }),
                            _c("div", { staticClass: "position-name" }, [
                              _vm._v(_vm._s(_vm.getPositionCN(pos)))
                            ])
                          ])
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "position-group",
                  style: _vm.getGroupStyle("MID")
                },
                _vm._l(_vm.currentFormation.MID, function(pos, idx) {
                  return _c(
                    "div",
                    {
                      key: "MID-" + idx,
                      staticClass: "position",
                      style: _vm.getPositionStyle("MID-" + idx),
                      attrs: { "data-pos-key": "MID-" + idx }
                    },
                    [
                      _vm.positionPlayers["MID-" + idx]
                        ? _c("div", { staticClass: "player draggable" }, [
                            _vm.positionPlayers["MID-" + idx].player_status !=
                              "sent_off" && _vm.matchInfo.status != 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "remove-btn",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.removePlayer("MID-" + idx)
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                )
                              : _vm._e(),
                            _c("img", {
                              staticClass: "avatar",
                              class: {
                                "status-sent-off":
                                  _vm.positionPlayers["MID-" + idx]
                                    .player_status == "sent_off" ||
                                  _vm.matchInfo.status == 2
                              },
                              attrs: {
                                src:
                                  _vm.positionPlayers["MID-" + idx].avatar ||
                                  require("@/assets/images/default_avatar.png")
                              }
                            }),
                            _c("div", { staticClass: "position-name" }, [
                              _vm._v(_vm._s(_vm.getPositionCN(pos)))
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "player-name",
                                class: {
                                  "name-sent-off":
                                    _vm.positionPlayers["MID-" + idx]
                                      .player_status == "sent_off" ||
                                    _vm.matchInfo.status == 2
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.positionPlayers["MID-" + idx].name
                                    ) +
                                    "#" +
                                    _vm._s(
                                      _vm.positionPlayers["MID-" + idx]
                                        .jersey_number
                                    )
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "empty-position" }, [
                            _c("div", { staticClass: "dot" }),
                            _c("div", { staticClass: "position-name" }, [
                              _vm._v(_vm._s(_vm.getPositionCN(pos)))
                            ])
                          ])
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "position-group",
                  style: _vm.getGroupStyle("FWD")
                },
                _vm._l(_vm.currentFormation.FWD, function(pos, idx) {
                  return _c(
                    "div",
                    {
                      key: "FWD-" + idx,
                      staticClass: "position",
                      style: _vm.getPositionStyle("FWD-" + idx),
                      attrs: { "data-pos-key": "FWD-" + idx }
                    },
                    [
                      _vm.positionPlayers["FWD-" + idx]
                        ? _c("div", { staticClass: "player draggable" }, [
                            _vm.positionPlayers["FWD-" + idx].player_status !=
                              "sent_off" && _vm.matchInfo.status != 2
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "remove-btn",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.removePlayer("FWD-" + idx)
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                )
                              : _vm._e(),
                            _c("img", {
                              staticClass: "avatar",
                              class: {
                                "status-sent-off":
                                  _vm.positionPlayers["FWD-" + idx]
                                    .player_status == "sent_off" ||
                                  _vm.matchInfo.status == 2
                              },
                              attrs: {
                                src:
                                  _vm.positionPlayers["FWD-" + idx].avatar ||
                                  require("@/assets/images/default_avatar.png")
                              }
                            }),
                            _c("div", { staticClass: "position-name" }, [
                              _vm._v(_vm._s(_vm.getPositionCN(pos)))
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "player-name",
                                class: {
                                  "name-sent-off":
                                    _vm.positionPlayers["FWD-" + idx]
                                      .player_status == "sent_off" ||
                                    _vm.matchInfo.status == 2
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.positionPlayers["FWD-" + idx].name
                                    ) +
                                    "#" +
                                    _vm._s(
                                      _vm.positionPlayers["FWD-" + idx]
                                        .jersey_number
                                    )
                                )
                              ]
                            )
                          ])
                        : _c("div", { staticClass: "empty-position" }, [
                            _c("div", { staticClass: "dot" }),
                            _c("div", { staticClass: "position-name" }, [
                              _vm._v(_vm._s(_vm.getPositionCN(pos)))
                            ])
                          ])
                    ]
                  )
                }),
                0
              )
            ]),
            _c(
              "div",
              { staticClass: "bench" },
              [
                _c("span", { staticClass: "bench-name" }, [_vm._v("替补席")]),
                _c(
                  "draggable",
                  {
                    attrs: { group: "players" },
                    on: { start: _vm.onDragStart, end: _vm.onDragEnd },
                    model: {
                      value: _vm.benchPlayers,
                      callback: function($$v) {
                        _vm.benchPlayers = $$v
                      },
                      expression: "benchPlayers"
                    }
                  },
                  _vm._l(_vm.benchPlayers, function(p) {
                    return _c(
                      "div",
                      {
                        key: p.student_id,
                        staticClass: "bench-item",
                        attrs: { "data-student-id": p.student_id }
                      },
                      [
                        _c("img", {
                          staticClass: "avatar-small",
                          attrs: {
                            src:
                              p.avatar ||
                              "../../../../assets/images/default_avatar.png"
                          }
                        }),
                        _c("span", [
                          _vm._v(
                            _vm._s(p.name) + " #" + _vm._s(p.jersey_number)
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                round: "",
                disabled: _vm.matchInfo.status == 2
              },
              on: { click: _vm.saveLineup }
            },
            [_vm._v("保存布阵")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }